import ServicePage from "@/components/ServicePage";

const Product = () => (
  <ServicePage
    pillar="CAPABILITY 02"
    title="AI & Product"
    ctaLabel="Discuss an AI & Product challenge"
    canonical="/services/product"
    seoTitle="AI & Product | Skandor Technologies"
    seoDescription="AI-powered product strategy, roadmap and build oversight — from initial concept to a product that can keep evolving."
    headline="AI-powered product strategy, roadmap and build oversight."
    lede="From initial concept to a product that can keep evolving. We define what to build, what to sequence, and what to leave for later — then stay accountable through build and launch."
    includes={[
      "Product diagnostic across users, market and competitive position",
      "Target product architecture and sequenced roadmap",
      "Build oversight by Skandor's senior team, matched to each engagement's technical fit, not handed off",
      "Go-to-market positioning integrated with product decisions",
      "Definition of done tied to measurable operating outcomes",
    ]}
    deliverables={[
      "Product diagnostic and priority map",
      "Sequenced roadmap with investment case",
      "Product in market with measurable adoption",
    ]}
    stages={[
      { n: "01", title: "Align", body: "Diagnose the product against users, market and internal constraints." },
      { n: "02", title: "Shape", body: "Convert the diagnosis into a fundable, sequenced roadmap." },
      { n: "03", title: "Build", body: "Deliver alongside the client team, led by a senior partner with a team matched to the engagement's technical fit." },
    ]}
  />
);

export default Product;
